module.exports = {
    RECEIVE_PROJECTION: 'RECEIVE_PROJECTION',
    RECEIVE_ALL_PROJECTION: 'RECEIVE_ALL_PROJECTION',
    SANDRE_PROJECTION_FIELD: 'SANDRE_LOCATION_FIELD',
}
